import React, { FC } from 'react';
import cx from 'classnames';
import { Territory as TTerritory } from 't2-graphql-types';
import { TerritoryLogo } from '../TerritoryHeader/TerritoryLogo';
import Typo from '../Typography/Typo';
import { TerritoryDetailsMembershipContainer } from './TerritoryDetailsMembershipContainer';
import { TerritoryDetailsMembers } from './TerritoryDetailsMembers';
import { TMember } from '../TerritoryMembersPopUp/MemberProfile';
import { TerritoryDetailsDescription } from './TerritoryDetailsDescription';
import { TerritoryDetailsTotalTimepoints } from './TerritoryDetailsTotalTimepoints';
import { TerritoryDetailsShareTerritory } from './TerritoryDetailsShareTerritory';
import { useTerritoryDetailsModalContext } from './context/TerritoryDetailsModalContextProvider';

type TTerritoryDetailsProps = {
  territory: TTerritory;
  territoryMembers: TMember[];
  territoryMembersCount: number;
  territoryHeaderLoading: boolean;
};

export const TerritoryDetails: FC<TTerritoryDetailsProps> = ({
  territory,
  territoryMembers,
  territoryMembersCount,
  territoryHeaderLoading,
}) => {
  const { handleOpenShareTerritoryModal } = useTerritoryDetailsModalContext();
  return (
    <div
      className={cx(
        'w-full md:h-[calc(100vh-136px)] py-4 px-5 md:border group-hover/sidebar:bg-t2-shades-white border-t2-neutral-grey03 rounded-[12px] z-10',
        'overflow-hidden',
      )}
    >
      <div className="flex items-center md:items-stretch md:flex-col gap-3">
        <div className="w-[95px] h-[95px] md:h-[75px] md:w-[75px]">
          <TerritoryLogo logo={territory?.logo} isLoading={false} />
        </div>
        <div className="flex flex-col gap-3">
          <Typo variant="p2" className="md:my-3 !text-[22px]">
            t/{territory?.name}
          </Typo>
          <div className="flex md:block gap-4 w-[138px] md:w-full">
            <TerritoryDetailsMembershipContainer
              territory={territory}
              isTerritoryHeaderLoading={territoryHeaderLoading}
            />
            <TerritoryDetailsShareTerritory openShareModal={handleOpenShareTerritoryModal} />
          </div>
        </div>
      </div>
      <div className="mt-6 flex flex-col">
        <div className="my-6 flex gap-8 md:gap-5 lg:gap-8 order-2 md:order-1 justify-between">
          <TerritoryDetailsMembers
            territory={territory}
            territoryMembers={territoryMembers}
            territoryMembersCount={territoryMembersCount}
            hideMembersCopy
          />
          <TerritoryDetailsTotalTimepoints
            territoryId={territory?.id}
            totalTerritoryTimePoints={Math.floor(territory?.totalTimePoints || 0)}
          />
        </div>
        <div className="order-1 md:order-2 overflow-y-auto md:max-h-[300px]">
          <TerritoryDetailsDescription description={territory?.description} />
        </div>
      </div>
    </div>
  );
};
